import type { ReactNode } from 'react';
import type { GameSnapshot } from '../engine/casino';
import { money, withCommas } from '../format';
import type { GameActions } from '../useGame';

/** The Bar, Gift Shop and elevator: a top bar with back and your bankroll,
 *  a body whose list scrolls inside itself, and an optional footer. The page
 *  itself never scrolls. */
export function MenuFrame({
  snapshot,
  actions,
  title,
  backLabel,
  children,
  footer,
}: {
  snapshot: GameSnapshot;
  actions: GameActions;
  title: string;
  backLabel: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  const run = snapshot.run!;
  return (
    <div className="menu-screen">
      <header className="table-top">
        <div className="table-top-row">
          <button className="icon-btn" onClick={actions.back} aria-label={backLabel}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>
          </button>
          <h1>{title}</h1>
          <span className="table-bankroll">{money(run.bankroll)}</span>
        </div>
      </header>
      <div className="menu-body">
        {snapshot.notice && <div className="notice" role="status">{withCommas(snapshot.notice)}</div>}
        {children}
      </div>
      {footer && <footer className="controls">{footer}</footer>}
    </div>
  );
}
